var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_3702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9788 7C14.3909 6.0801 13.5809 5.32307 12.6234 4.79876C11.6658 4.27445 10.5917 3.99974 9.5 4C9.0144 4.83956 8.72314 5.77729 8.64765 6.74423C8.57215 7.71117 8.71434 8.68274 9.06375 9.5875C8.37968 10.5949 8.00951 11.7824 8 13V14C8 15.5913 8.63214 17.1174 9.75736 18.2426C10.8826 19.3679 12.4087 20 14 20H20C21.5913 20 23.1174 19.3679 24.2426 18.2426C25.3679 17.1174 26 15.5913 26 14V13C25.9905 11.7824 25.6203 10.5949 24.9363 9.5875C25.2857 8.68274 25.4278 7.71117 25.3524 6.74423C25.2769 5.77729 24.9856 4.83956 24.5 4C23.4083 3.99974 22.3342 4.27445 21.3766 4.79876C20.4191 5.32307 19.6091 6.0801 19.0212 7H14.9788Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 29V24C13 22.9391 13.4214 21.9217 14.1716 21.1716C14.9217 20.4214 15.9391 20 17 20C18.0609 20 19.0783 20.4214 19.8284 21.1716C20.5786 21.9217 21 22.9391 21 24V29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 26H9C7.93913 26 6.92172 25.5786 6.17157 24.8284C5.42143 24.0783 5 23.0609 5 22C5 20.9391 4.57857 19.9217 3.82843 19.1716C3.07828 18.4214 2.06087 18 1 18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_3702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.4b5d3c998f3e6b417182550e6c754a46.svg";
export { ForwardRef as ReactComponent };